import React, { useEffect, useState, useMemo } from "react";
import { Table, Spin } from 'antd';
import { useAuth } from "react-oidc-context";
import { GetCampaignQAResults } from "../services/ApiService";
import {
  GetCampaignStatus,
  GenerateCampaignDeskUrl,
} from "../services/UtilService";
import Alert from "react-bootstrap/Alert";
const CampaignQAResultUI = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const auth = useAuth();
  const [showError, setShowError] = useState(false);
  const columns = useMemo(
    () => [
      {
        dataIndex: "campaign_id",
        key: "cid",
        title: "Campaign Id",
        render: (text, record) => (
          <a
            href={GenerateCampaignDeskUrl(
              record.campaign_id,
              record.partner_id,
            )}
            target="_blank"
            rel="noopener noreferrer"
          >
            {record.campaign_id}
          </a>
        ),
      },
      {
        dataIndex: "start_date",
        key: "start_date",
        title: "Start Date",
        sorter: (a, b) => a.start_date.localeCompare(b.start_date),
      },
      {
        dataIndex: "end_date",
        key: "end_date",
        title: "End Date",
        sorter: (a, b) => a.end_date.localeCompare(b.end_date),
      },
      {
        dataIndex: "latest_bidlist_association",
        key: "latest_bidlist_association",
        title: "Bidlist Association(Latest)",
        sorter: (a, b) =>
          a.latest_bidlist_association.localeCompare(
            b.latest_bidlist_association,
          ),
      },
      {
        dataIndex: "execution_date",
        key: "execution_date",
        title: "Execution Date",
        sorter: (a, b) => a.execution_date.localeCompare(b.exectuion_date),
      },
      {
        dataIndex: "bidlist_id",
        key: "bidlist_id",
        title: "Bidlist Id",
        render: (text, record) => {
          return record.bidlist_id.replace(/\.0$/, "");
        },
        sorter: (a, b) => a.bidlist_id.localeCompare(b.bidlist_id),
      },
      {
        dataIndex: "bidlist_type",
        key: "bidlist_type",
        title: "Bidlist Type",
        sorter: (a, b) => a.bidlist_type.localeCompare(b.bidlist_type),
      },
      {
        dataIndex: "bidlist_name",
        key: "bidlist_name",
        title: "Bidlist Name",
        sorter: (a, b) => a.bidlist_name.localeCompare(b.bidlist_name),
      },
      {
        dataIndex: "event_type",
        key: "event_type",
        title: "Event Type",
        sorter: (a, b) => a.event_type.localeCompare(b.event_type),
      },
      {
        dataIndex: "bidlines",
        key: "bidlines",
        title: "Bidlines",
        sorter: (a, b) => a.bidlines.localeCompare(b.bidlines),
      },
      {
        dataIndex: "is_kokai",
        key: "is_kokai",
        title: "Is Kokai",
        sorter: (a, b) => a.is_kokai.localeCompare(b.is_kokai),
      },
      {
        dataIndex: "bid_ratio",
        key: "bid_ratio",
        title: "Bid Ratio",
        sorter: (a, b) => a.bid_ratio.localeCompare(b.bid_ratio),
      },
    ],
    [],
  );

  useEffect(() => {
    const fetchData = async () => {
      try {
        const raw_data = await GetCampaignQAResults(auth.user.id_token);
        console.log(raw_data);

        const data = raw_data.map((campaign) => {
          const { status, color } = GetCampaignStatus(
            campaign.start_date,
            campaign.end_date,
          );
          return {
            ...campaign,
            campaign_status: status,
            campaign_status_color: color,
          };
        });
        setData(data);
        setLoading(false);
      } catch (err) {
        console.log(err.message);
        setError("Failed to retrieve the onboarded campaigns");
        setLoading(false);
        setShowError(true);
      }
    };
    fetchData();
  }, [auth.user.id_token]);

  if (loading) return <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '50vh' }}><Spin size="large" /></div>;

  return (
    <div className="table-container">
      {showError && (
        <Alert variant="danger" onClose={() => setShowError(false)} dismissible>
          <Alert.Heading>Error!</Alert.Heading>
          <p>{error}</p>
        </Alert>
      )}
      <Table dataSource={data} columns={columns} rowKey={(record) => `${record.campaign_id}-${record.execution_date}-${record.bidlist_id}`} pagination={{ pageSize: 10, showSizeChanger: true }} />
    </div>
  );
};

export default CampaignQAResultUI;
